import { render, staticRenderFns } from "./SetDoughsStep.vue?vue&type=template&id=adcd39de&scoped=true&"
import script from "./SetDoughsStep.vue?vue&type=script&lang=js&"
export * from "./SetDoughsStep.vue?vue&type=script&lang=js&"
import style0 from "./SetDoughsStep.vue?vue&type=style&index=0&id=adcd39de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcd39de",
  null
  
)

export default component.exports